// **** import modules ****
import app, { csl } from "@@assets/scripts/common";
import vuwer from "@@assets/scripts/vuwer";


// **** process ****
app.onReady((...args) => {
	csl.log.orange(`${app.pageName} onReady`, ...args);
});

vuwer.get("pageHeader").setProp({
	setTitle() {
		return this;
	}
}, true);

app.exec();
